
















import {Component, Inject, Prop} from "vue-property-decorator";
    import UserCard from "../user-card/UserCard.vue";
    import UserRequired from "../UserRequired";

    @Component({
        components: {
            "at-user-card": UserCard
        }
    })
    export default class UserCardContainer extends UserRequired {
      @Prop({default: false})
      triggerEmailAdd!: boolean;

      get activeCompany() {
        return this.baseApi.company;
      }

      get personData() {
        return this.baseApi.user;
      }

      onUserChanged() {
        this.baseApi.loadUser();
      }
    }
